import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentProfileCompletionPercentage(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentProfileCompletionPercentage.url, { id }))
    .get<number>()
}
